<div class="content popup-content white-bg-float-label" style="height: 200px !important;">
    <div fxLayout="column" fxLayoutAlign="start" fxLayout.gt-md="row">
        <form [formGroup]="InviteAssociateFormGroup" class="form_field" (ngSubmit)="InviteAssociate()"
            fxLayout="column" fxLayoutAlign="start" fxFlex="1 0 auto">
            <div class="popup-header">
                <mat-toolbar class="mat-accent m-0"style="background-color: #2e5d97 !important;">
                    <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
                        <span class="title dialog-title">Invite Buyer Associate</span>
                        <button mat-icon-button [mat-dialog-close]="true" aria-label="Close dialog" tabindex="-1">
                            <mat-icon>close</mat-icon>
                        </button>
                    </mat-toolbar-row>
                </mat-toolbar>
            </div>
            <div fxLayout.xs="column" fxLayoutAlign="center center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>Email</mat-label>
                    <input type="email" matInput formControlName="email">
                    <mat-icon matSuffix class="secondary-text">mail</mat-icon>
                    <mat-error *ngIf="InviteAssociateFormGroup.get('email').hasError('required')">Email is required, Please enter a valid email address</mat-error>
                    <mat-error *ngIf="InviteAssociateFormGroup.get('email').hasError('pattern')">
                        domain should match with your email domain
                    </mat-error>
                </mat-form-field>
            </div>
            <!-- <div [fxLayout]="direction" fxLayout.xs="column" fxLayoutAlign="center center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>New Password</mat-label>
                    <input type="password" matInput formControlName="new_password">
                    <mat-error *ngIf="ChangePasswordFormGroup.get('new_password').hasError('required')">New password is
                        required</mat-error>
                </mat-form-field>
            </div>
            <div [fxLayout]="direction" fxLayout.xs="column" fxLayoutAlign="center center" fxFlex="1 0 auto">
                <mat-form-field appearance="outline" fxFlex="100" class="pr-4">
                    <mat-label>Confirm Password</mat-label>
                    <input type="password" matInput formControlName="confirm_password">
                    <mat-error *ngIf="ChangePasswordFormGroup.get('confirm_password').hasError('required')">
                        Confirm password is required
                    </mat-error>
                    <mat-error *ngIf="!ChangePasswordFormGroup.get('confirm_password').hasError('required') &&
                    ChangePasswordFormGroup.get('confirm_password').hasError('passwordsNotMatching')">
                        Password and Confirm password should match
                    </mat-error>
                </mat-form-field>
            </div> -->
            <div class="example-button-row" fxLayoutAlign="center">
                <button mat-raised-button color="accent" class="mr-12 submit-button">Submit</button>
                <!-- <a mat-raised-button color="accent" (click)="dialogClose()">Cancel</a> -->
            </div>
        </form>

    </div>
</div>